import { ActionType } from "../../interfaces/storeFactory"


export interface IWhere2goState {
    date: number,
    period: number,
    radius: number,
}

export const SET_DATE = "SET_DATE"
export const SET_PERIOD = "SET_PERIOD"
export const SET_RADIUS = "SET_RADIUS"
export const SET_WHERE2GO = "SET_WHERE2GO"

export const setDate = (date: number): ActionType<Partial<IWhere2goState>> => ({
    type: SET_DATE,
    payload: { date, },
})

export const setPeriod = (period: number): ActionType<Partial<IWhere2goState>> => ({
    type: SET_PERIOD,
    payload: { period, }
})

export const setRadius = (radius: number): ActionType<Partial<IWhere2goState>> => ({
    type: SET_RADIUS,
    payload: { radius, }
})

export const setState = (date: number, period: number, radius: number): ActionType<IWhere2goState> => ({
    type: SET_WHERE2GO,
    payload: {
        date,
        period,
        radius,
    }
})
